import { Box, Flex, Spinner, Text } from "@chakra-ui/react";
import { WithdrawalTable } from "../../components/WithdrawalTable/WithdrawalTable";
import { WithdrawalTicket } from "../../helpers/dataStructures";
import { ThemeColor } from "../../theme/palette";
import { useStakeWithdrawalTickets } from "./StakeWithdrawalTicketsContext";

interface WithdrawalTicketsSectionProps {
  currentEpoch: number;
  onClaimClick: (ticket: WithdrawalTicket) => void;
  onClaimAll?: (readyTickets: WithdrawalTicket[]) => void;
  claimingTicketId: string | null;
  isBatchClaiming?: boolean;
  currency: string;
  image: string;
}

export const WithdrawalTicketsSection = ({
  currentEpoch,
  onClaimClick,
  onClaimAll,
  claimingTicketId,
  isBatchClaiming,
  currency,
  image,
}: WithdrawalTicketsSectionProps) => {
  const { tickets, isLoading } = useStakeWithdrawalTickets();

  if (isLoading) {
    return (
      <Box
        py={8}
        px={4}
        borderRadius="xl"
        border="1px solid"
        borderColor="whiteAlpha.200"
        bg="whiteAlpha.50"
      >
        <Flex direction="column" align="center" justify="center" gap={3}>
          <Spinner size="md" color={ThemeColor.KAIROS} thickness="3px" />
          <Text fontSize="sm" color="whiteAlpha.600">
            Loading unstaking requests…
          </Text>
        </Flex>
      </Box>
    );
  }

  if (tickets.length === 0) {
    return null;
  }

  const readyTickets = tickets.filter((t) => currentEpoch >= t.availableEpoch);

  return (
    <WithdrawalTable
      tickets={tickets}
      currentEpoch={currentEpoch}
      onClaimClick={onClaimClick}
      onClaimAll={
        readyTickets.length >= 2 && onClaimAll
          ? () => onClaimAll(readyTickets)
          : undefined
      }
      claimingTicketId={claimingTicketId}
      isBatchClaiming={isBatchClaiming}
      currency={currency}
      image={image}
    />
  );
};
